export const environment = {
  version: '8.4.1',
  production: false,
  deployUrl: 'https://dev.pricing.calenso.com',
  brandName: 'Calenso',
  websiteUrl: 'https://www.calenso.com',
  supportEmail: 'support@calenso.com',
  componentTag: 'calenso-pricing-table',
};
